(() => {
  if (!('IntersectionObserver' in window) || !Element.prototype.animate) return;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const active = new Map();
  const reveal = (element, immediate = false) => {
    if (seen.has(element)) return;
    seen.add(element);
    observer.unobserve(element);
    if (immediate || motion.matches) return;
    const animation = element.animate([
      { opacity: 0, translate: innerWidth > 800 ? '0 64px' : '0 44px' },
      { opacity: 1, translate: '0 0' }
    ], { duration: 1050, easing: 'cubic-bezier(.2,.65,.3,1)' });
    active.set(element, animation);
    animation.onfinish = animation.oncancel = () => active.delete(element);
  };
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => { if (isIntersecting) reveal(target); });
  });
  const revealSelectors = [
    '[data-reading-reveal]',
    '.reading-product__main-image',
    '.reading-product__thumbnails',
    '.reading-product__recognition',
    '.reading-product__details > h1',
    '.reading-product__description',
    '.reading-product__booking',
    '.book-reader-reviews__heading',
    '.book-reader-reviews .splide',
    '.reading-product-videos > h2',
    '.reading-product-videos .jhp-hero__gallery',
    '.reading-product-support .home-flow-heading',
    '.reading-product-support .google-review-card',
    '.reading-product-support .home-reviews-actions'
  ];
  const setup = () => {
    document.querySelectorAll(revealSelectors.join(',')).forEach((element) => {
      if (seen.has(element)) return;
      element.setAttribute('data-reading-reveal', '');
      const rect = element.getBoundingClientRect();
      if (rect.top < innerHeight && rect.bottom > 0) reveal(element, true);
      else observer.observe(element);
    });
  };
  document.addEventListener('focusin', ({ target }) => {
    const element = target.closest('[data-reading-reveal]');
    if (element) { reveal(element, true); active.get(element)?.cancel(); }
  });
  motion.addEventListener('change', () => {
    if (motion.matches) active.forEach((animation) => animation.cancel());
  });
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('google-reviews-loaded', setup);
  setup();
})();
